import { render } from "./PersonalAccessTokens.vue?vue&type=template&id=608de639&scoped=true"
import script from "./PersonalAccessTokens.vue?vue&type=script&lang=js"
export * from "./PersonalAccessTokens.vue?vue&type=script&lang=js"

import "./PersonalAccessTokens.vue?vue&type=style&index=0&id=608de639&scoped=true&lang=css"

import exportComponent from "/home/gary/Git-Projects/rcmg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-608de639"]])

export default __exports__